import { Integration } from 'signup-constants/Integration';
export const IntegrationName = {
  [Integration.DesignKitGenerator]: 'DesignKitGenerator',
  [Integration.Wordpress]: 'Wordpress',
  [Integration.Wpforms]: 'WPForms',
  [Integration.Shopify]: 'Shopify',
  [Integration.Typeform]: 'Typeform'
};